import router from '@/router'
import store from "@/store";

const UNAUTHORIZED_ERROR_CODE = 403

export default (client) => {
  client.interceptors.response.use(
    function (response) {
      return response
    },
    function (error) {
      if (UNAUTHORIZED_ERROR_CODE === error.response.status) {
        // Reset the abilities, so when the user re-login, the data will be refreshed
        store.commit("core/resetAbilites");
        router.push('/login').catch(() => {})
        return Promise.reject(error)
      } else {
        return Promise.reject(error)
      }
    })
}
